import { gql } from '@apollo/client';

const schema = {
  assign: {
    name: 'updateOrCreateUserCategoryItem',
    serviceName: 'unitadmin',
    query: gql`
      mutation updateOrCreateUserCategoryItem($category_id: String!, $user_ids: [String]!, $insert_type: String) {
        updateOrCreateUserCategoryItem(category_id: $category_id, user_ids: $user_ids, insert_type: $insert_type) {
          messages
        }
      }
    `,
  }
};

export default schema;
